module.exports = __webpack_public_path__ + "img/69600.92d16f68.jpg";